<template>
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>View Project</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>View Project</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->

            <div class="content with-padding padding-bottom-10">
              <div class="row">
                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Project Title</h5>
                    <input
                    disabled
                      type="text"
                      class="with-border"
                      v-model="updatedProject.title"
                    />
                    
                  </div> 
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Project Model</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                        disabled
                          title="Select Project Model"
                          v-model="updatedProject.model"
                          @change="changeModel($event)"
                        >
                          <option >
                            {{model}}
                          </option>
                          <option  v-for="(model, index) in models" :key="index" :value="Number(index)" >{{ model }}</option>
                        </select> 
                      </div>
                      <i class="icon-feather-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Task Category</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select title="Select Task Category" disabled v-model="updatedProject.task_id" >
                          <option :value="task.id">
                            {{taskname}}
                          </option>
                          <option v-for="task in tasks" :key="task.id" :value="task.id"> {{task.name}} </option>
                        </select>
                      </div> 
                      <i class="icon-feather-chevron-down"></i> 
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Sub-Task Category</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                        disabled
                          v-model="updatedProject.sub_task_id"
                           @change="getSubTasks()"
                           title="Select Sub-Task Category"
                        >
                          <option :value="subtask.id" >
                            {{subtaskname}}
                          </option>
                          <option v-for="task in tasks" :key="task.id" :value="task.id">{{task.name}}</option>
                        </select> 
                      </div>
                      <i class="icon-feather-chevron-down"></i>   
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Number of Task Masters</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select title="Select Project Model" disabled v-model="updatedProject.num_of_taskMaster">
                          <option>
                            {{ updatedProject.num_of_taskMaster}}
                          </option>
                          <option v-for="taskMaster in numOfTaskMasters" :key="taskMaster">{{taskMaster}}</option>
                        </select>
                      </div>
                      <i class="icon-feather-chevron-down"></i>  
                    </div>
                  </div>
                </div>

                <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>Country</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                        disabled
                          title="Select Project Model"
                          @change="getCountryId($event)"
                          v-model="updatedProject.country_id"
                        >
                          <option :value="updatedProject.country.id">
                            {{updatedProject.country.name}}
                          </option>
                          <option v-for="country in countries" :key="country.id" 
                            :value="country.id">{{country.name}}</option>
                        </select>
                      </div> 
                      <i class="icon-material-outline-location-on"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>Region</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                        disabled
                          title="Select Project Model"
                          @change="getRegionId($event)"
                          v-model="updatedProject.region_id"
                        >
                          <option :value="updatedProject.region.id">
                           {{updatedProject.region.name}}
                          </option>
                          <option v-for="region in regions" :key="region" :value="region.id">{{region.name}}</option>
                        </select>
                      </div>
                      <i class="icon-material-outline-location-on"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>City</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select title="Select Project Model" disabled v-model="updatedProject.city_id">
                          <option :value="updatedProject.city.id" >
                            {{updatedProject.city.name}}
                          </option>
                          <option
                            v-for="city in cities"
                            :key="city.id"
                            :value="city.id"
                          >
                            {{ city.name}}
                          </option>
                        </select>
                      </div>
                      <i class="icon-material-outline-location-on"></i>
                    </div>
                  </div>
                </div>



               <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>Address</h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                        disabled
                          type="text"
                          class="keyword-input with-border"
                          placeholder="12, Rolag Crescent, Ajah"
                          v-model="updatedProject.address"
                        />
                      </div>
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>



                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Experience Level</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select title="Select Project Model" disabled v-model="updatedProject.experience">
                          <option>
                            {{experience}}
                          </option>
                          <option
                            v-for="(option, index) in expertise"
                            :key="index"
                            :value="index"
                          >
                            {{ option }}
                          </option>
                        </select> 
                      </div>
                      <i class="icon-feather-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Budget</h5>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="input-with-icon">
                          <input
                          disabled
                            class="with-border"
                            type="text"
                            placeholder="Budget"
                            v-model="updatedProject.budget"
                          />
                          <i class="currency">NGN</i> 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>
                      Tags <span>(optional)</span>
                      <i
                        class="help-icon"
                        data-tippy-placement="right"
                        title="Maximum of 10 tags"
                      ></i>
                    </h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                        disabled
                          type="text"
                          class="keyword-input with-border"
                          placeholder="e.g. job title, responsibilites"
                        />
                        <button class="keyword-input-button ripple-effect">
                          <i class="icon-material-outline-add"></i>
                        </button>
                      </div>
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Proposed Start Date</h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                          type="date"
                          class="keyword-input with-border"
                          :placeholder="updatedProject.proposed_start_date"
                         disabled
                          v-model="updatedProject.proposed_start_date"
                        />
                      </div> 
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Duration of Project</h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                          type="text"
                          disabled
                          class="keyword-input with-border"
                          placeholder="2 months"
                          v-model="updatedProject.duration"
                        />
                      </div> 
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12">
                  <div class="submit-field">
                    <h5>Job Description</h5>
                    <textarea
                      cols="30"
                      rows="5"
                      class="with-border"
                      disabled
                      v-model="updatedProject.description"
                    ></textarea> 
                    <!-- <div class="uploadButton margin-top-30">
                      <input
                      disabled
                        class="uploadButton-input"
                        type="file"
                        ref="file"
                        id="upload"
                        accept="image/*, application/pdf" 
                        @change="uploadFile($event)"
                        
                      />
                      <label
                        class="uploadButton-button ripple-effect"
                        for="upload"
                        
                        >Upload Files</label
                      >
                      <span class="uploadButton-file-name" 
                        >  {{ file ? file.name : 'Images or documents that might be helpful in describing your job' }} </span
                      >
                     
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-xl-12">
          <a
            href="#"
            class="button ripple-effect big margin-top-30"
            @click="updateProject()"
            ><i class="icon-feather-plus"></i> Update Job</a
          >
        </div> -->
      </div>
      <!-- Row / End -->

      <!-- Row -->

      <!-- Row / End -->

      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { GET_SINGLE_PROJECT } from "../../../core/config/endpoints/projects";
import {PROJECT_ATTRIBUTES} from "../../../core/config/endpoints/projects";
import { ALL_TASKS_AND_SUBTASKS} from "../../../core/config/endpoints/tasks";
import { getCall } from "../../../core/services/http.service";
import {
  COUNTRIES,
  GET_REGION_WITH_COUNTRY_ID,
  GET_CITIES_WITH_REGION_ID,
} from "../../../core/config/endpoints/location";

export default {
  data() {
    return {
      task:{},
      subtask: {},
      isRemote: '',
      tasks: {},
      regions: {},
      countries:{},
      cities: {},
      models:{},
      model:'',
      country: '',
      region:'',
      file: '',
      experience: '',
      proposed_start_date: '',
      projectId: 0,
      city:'',
      expertise:'',
      project: {

      },
      updatedProject: {
        project_id :0,
        model: 0,
        task_id: 0,
        num_of_taskMaster: 0,
        budget: 0,
        experience: 0,
        proposed_start_date:'',
        description: "",
        title: "",
        sub_task_id: 0,
        country_id: 0,
        city_id: 0,
        region_id: 0,
        duration: ""
      }
     
    };
  },
  created() {
    this.getProjectAttributes()
    this.getAllTasks()
    this.getAllCountries();
  },
  mounted() {
    this.getSingleProject();
  },
  
  methods: {
    getSingleProject() {
      this.$store.commit("setIsLoaded", true);
      getCall(GET_SINGLE_PROJECT.SINGLE_PROJECT(this.$route.params.id))
        .then((response) => {
          let data = response.data.data[0]
          this.updatedProject = data
          this.updatedProject.project_id = data.id
          if(this.updatedProject.model === 1){
            this.isRemote = true
            delete this.updatedProject["city_id", "region_id", "country_id"]
          }else{
            this.isRemote = false
             this.updatedProject.city_id = data.city_id
             this.updatedProject.region_id = data.region_id
             this.updatedProject.country_id = data.country_id
          }
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    getProjectAttributes() {
      getCall(PROJECT_ATTRIBUTES)
        .then((response) => {
         
          this.expertise = response.data.data.expertise;
          this.status = response.data.data.status;
          this.models = response.data.data.model;
          this.numOfTaskMasters = response.data.data.numOfTaskMasters;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    getAllTasks() {
      this.$store.commit("setIsLoaded", true);
      getCall(ALL_TASKS_AND_SUBTASKS)
        .then((response) => {
          this.tasks = response.data.data;
          this.tasks.sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
       getSubTasks() {},
    getAllCountries() {
      this.$store.commit("setIsLoaded", true);
      getCall(COUNTRIES)
        .then((response) => {
          this.countries = response.data.data;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    
    getAllRegions() {
      this.$store.commit("setIsLoaded", true);
      getCall(GET_REGION_WITH_COUNTRY_ID.COUNTRY_ID(this.countryId))
        .then((response) => {
          this.regions = response.data.data;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
     getAllCities() {
      this.$store.commit("setIsLoaded", true);
      getCall(GET_CITIES_WITH_REGION_ID.REGION_ID(this.regionId))
        .then((response) => {
          this.cities = response.data.data;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
     getCountryId(e) {
      let id = e.target.value;
      this.updatedProject.country_id = id;
      this.countryId = id;
      this.getAllRegions();
    },
     getRegionId(e) {
      let id = e.target.value;
      this.regionId = id;
      this.updatedProject.region_id = id;
      this.getAllCities();
    },
     changeModel(e) {
      let id = e.target.value;
      if (id == "remote" ) {
        this.isRemote = true;
      } else {
        this.isRemote = false;
      }

      
    },
  },
};
</script>

<style>
</style>